import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { SubmitType } from '../fieldConfigurations';
import { SubmitButtonProps, SubmitButton } from '@app/core';
import { Trans } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  button: {
    textAlign: 'center',
    marginTop: theme.marginBase * 7,
  },
}));

interface Props {
  submitType?: SubmitType;
  disabled?: boolean;
}

export const CustomFormFieldSubmitButton = ({
  submitType,
  ...rest
}: Props & SubmitButtonProps) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  switch (submitType) {
    case SubmitType.DONE:
      return (
        <div className={classes.button}>
          <SubmitButton color="green" {...rest}>
            <Trans i18nKey="screeningForm.end" />
          </SubmitButton>
        </div>
      );
    default:
    case SubmitType.CONTINUE:
      return (
        <div className={classes.button}>
          <SubmitButton withNextArrow {...rest}>
            <Trans i18nKey="screeningForm.continue" />
          </SubmitButton>
        </div>
      );
  }
};
